import { Config } from "@/app/config";
import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./Fields.scss";
import useModals from "@/shared/hooks/useModal";
import Modal from "@/components/Modal/Modal";


interface ITexInput extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLSpanElement>, HTMLSpanElement> {
    value?: any, label?: string, empty?: string 
}

export function TextField({ value, label, empty, ...props }: ITexInput ) {
    return <span className='text-14' {...props}>{value || empty}</span>
}

export function RictTextField({ value, label, empty, ...props }: ITexInput) {
    return (
        <span
            className='text-14'
            {...props}
            dangerouslySetInnerHTML={{ __html: value || empty }}
        />
    )
}

export function FileField({ value, label, empty, ...props }: ITexInput){
    function isImage(filename: string) {
        const extensions = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "svg"]
        return extensions.map((el: string)=>filename.includes(el)).some(el=>!!el)
    }

    function isVideo(filename: string) {
        const extensions = ["mp4", "mov", "avi", "wmv", "mkv", "webm"]
        return extensions.map((el: string)=>filename.includes(el)).some(el=>!!el)
    }
    if (isVideo(value as string)) return <VideoField value={value} label={label} empty={empty} {...props} />
    if (isImage(value as string)) return <ImageField value={value} label={label} empty={empty} {...props} />
    return <DocumentField value={value} label={label} empty={empty} {...props} />
}

export function ImageField({ value, label, empty, ...props }: ITexInput ) {
    const {openModal, closeModal} = useModals();
    const onClick = () => {
        openModal(
            <Modal close={()=>closeModal()}>
                <img src={`${Config.HOST_URL}/${value}`}/>
            </Modal>
        )
    }
    // @ts-ignore
    return <img className="ImageField" src={`${Config.HOST_URL}/${value}`} onClick={onClick} {...props} />
}

export function VideoField({ value, label, empty, ...props }: ITexInput ) {
    const {openModal, closeModal} = useModals();
    const onClick = () => {
        openModal(
            <Modal close={()=>closeModal()}>
                <video src={`${Config.HOST_URL}/${value}`}/>
            </Modal>
        )
    }
    // @ts-ignore
    return <video className="VideoField" src={`${Config.HOST_URL}/${value}`} onClick={onClick} {...props}/>
}

export function DocumentField({ value, label, empty, ...props }: ITexInput ) {
    // @ts-ignore
    return <a href={`${Config.HOST_URL}/${value}`} {...props}>{value}</a>
}


export function DateTimeField({ value, key, label, empty }: { key: string, value?: any, label?: string, empty?: string }) {
    return <span className='text-14'>{(new Date(value)).toLocaleString('ru-Ru')}</span>
}
export function ShowButton({ value, key, label, urlPrefix }: { key: string, value?: any, label?: string, urlPrefix: string }) {
    const navigate = useNavigate();
    return <Button onClick={() => navigate(urlPrefix + value)}>{label || "Перейти"}</Button>
}
export function EditButton({ value, key, label, urlPrefix }: { key: string, value?: any, label?: string, urlPrefix: string }) {
    const navigate = useNavigate();
    return <div className='text-14 cursor-pointer red' onClick={() => navigate(urlPrefix + value)}>{label || "Редактировать"}</div>
}
export function RecordField({ record, render, label }: { record?: any, render: (record: any)=>JSX.Element, label?: string, }) {
    if (!record) return <></>
    return render(record);
}
export function ReferenceField({ value, key, label, empty, fetcher, field, ...props }: any ){
    const [refValue, setRefValue] = React.useState<any>();
    React.useEffect(()=>{
        fetcher(value).then((res)=>{
            setRefValue(res.data[field])
        })
    }, [])
    return <span className='text-14' {...props}>{refValue || value || empty}</span>
}
export function ArrayField({ value, key, label, empty, children, ...props }: any ){
    const childrens = Array.isArray(children)? children: [children]
    if (!value || !(value.length > 0)) return <TextField value={empty || "Нет значений"} />
    return (
        <div>
        {value?.map((record: any)=>{
            return (
                <>
                {
                    childrens?.map((element: any)=>
                        React.cloneElement(element, {value: element.props.key ? record[element.props.key]: record})
                    )
                }
                </>
            )
        }
        )}
        </div>
    )
}